import React, { useState } from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import PageBanner from '../Components/Other/PageBanner'
function HFC(props) {
  const [tab, setTab] = useState(1)
  return (
    <PageWrapper className={"index-page"}>

      <div className="pageWrapper">
        <div className="web-sect pageBox">
          <PageBanner pageName={"Homoeopathic Forever Charity"}></PageBanner>
        </div>
        <div className="MainContent">
          <div className="container">
            <div className="page-rte">

              <div class="row"><div class="col-12 textCenter"><img src={require('../img/hfc.png')} /></div></div>
              <div className='padding_img'></div>
              <p>
                Any good and great deed starts from the bitter experiences of the
                past. So let's talk about 2010-2011 when we were in our medical
                college internship. At that time there was a seminar by a famous and
                very good homoeopathic doctor in Surat, from which there was a lot to
                learn about homoeopathic practice, we people had to fill this seminar,
                but we had to pay a certain amount to attend this seminar, and the
                amount we could not pay as a student at that time, despite the burning
                hunger for knowledge, we could not satisfy that hunger for knowledge
                due to lack of money
              </p>
              <p>
                This is just the moment when we made up our minds that we should not
                allow future homoeopathic students to suffer from this problem, we
                will be drowning in a river of knowledge in which no thirsty student
                will be deprived of knowledge due to lack of money.
              </p>
              <p>
                So the concept of Homeopathy Forever Charity was born in 2011 but it
                came into existence on paper and in the real world, on 2-01-2020. But
                we, the people, organised a free homoeopathic seminar for homoeopathic
                students on 20-1-2017, just a year ago before the documental birth of
                homoeopathy forever charity. Now it was our moral and primary duty not
                to let this flowing knowledge of Ganga stop us, since then we have so
                far recruited more than 1500 Homoeopathic students from Surat, Rajkot,
                Mumbai by renowned doctors and experienced and veteran professors of
                medical colleges for homoeopathic students. Through these seminars,
                there is an opportunity to get soaked in the flowing Ganges of
                knowledge.
              </p>
              <p>
                In our private practice, we have noticed many times that there are
                many misconceptions about homoeopathy within people and society. Since
                many patients have many misconceptions about diseases other than
                homoeopathy, a good homoeopathic doctor must dispel these doubts and
                misconceptions, so we thought that these common people should also get
                a chance to wash their feet in the flowing Ganges of the knowledge of
                homoeopathy forever charity.
              </p>
              <p>
                So with such an ideological power, we have organised 6 seminars from
                Homeopathy Forever in different places in Surat to date for
                maintaining the physical and mental health of the common people and
                for the permanent treatment and counselling of related diseases in
                which a total of more than 2000 people talked about the importance and
                maintenance of their physical and mental health. They have also
                learned through online seminars how to raise a child in terms of
                psychology through our medium of Homeopathy forever charity.
              </p>
              <p>
                During the first lockdown of 2020, about 100 doctors from India,
                Japan, Canada and Pakistan participated in this online session under
                the banner "Homoeopathic Gurukul" to enhance their knowledge of
                homoeopathy.
              </p>
              <p>
                We will still be trying to reach out to homoeopathic students,
                homoeopathic practitioners and others in the community through
                Homeopathy Forever Charity.
              </p>
            </div>
          </div>
        </div>
      </div>

    </PageWrapper>

  );
}

export default HFC;